import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "bar", "toggleButton", "count" ]

  connect() {
    this.active = false
    this.selectedIds = new Set()
    this.handleCardClick = this.handleCardClick.bind(this)
  }

  disconnect() {
    if (this.active) {
      this.element.removeEventListener("click", this.handleCardClick, true)
    }
  }

  toggle() {
    this.active ? this.exit() : this.enter()
  }

  enter() {
    this.active = true
    this.element.classList.add("is-select-mode")
    this.element.addEventListener("click", this.handleCardClick, true)
    if (this.hasBarTarget) this.barTarget.classList.remove("hidden")
    if (this.hasToggleButtonTarget) {
      this.toggleButtonTarget.textContent = "Cancel selection"
      this.toggleButtonTarget.classList.remove("btn-secondary")
      this.toggleButtonTarget.classList.add("btn-dark-secondary")
    }
    this.updateCount()
  }

  exit() {
    this.active = false
    this.element.classList.remove("is-select-mode")
    this.element.removeEventListener("click", this.handleCardClick, true)
    this.selectedIds.clear()
    this.element.querySelectorAll(".is-selected-card").forEach(el =>
      el.classList.remove("is-selected-card", "ring-4", "ring-amber-400", "ring-offset-2")
    )
    if (this.hasBarTarget) this.barTarget.classList.add("hidden")
    if (this.hasToggleButtonTarget) {
      this.toggleButtonTarget.textContent = "Select"
      this.toggleButtonTarget.classList.add("btn-secondary")
      this.toggleButtonTarget.classList.remove("btn-dark-secondary")
    }
  }

  handleCardClick(event) {
    const card = event.target.closest("[data-book-id]")
    if (!card || !this.element.contains(card)) return

    event.preventDefault()
    event.stopPropagation()

    const bookId = card.dataset.bookId
    if (this.selectedIds.has(bookId)) {
      this.selectedIds.delete(bookId)
      card.classList.remove("is-selected-card", "ring-4", "ring-amber-400", "ring-offset-2")
    } else {
      this.selectedIds.add(bookId)
      card.classList.add("is-selected-card", "ring-4", "ring-amber-400", "ring-offset-2")
    }
    this.updateCount()
  }

  updateCount() {
    if (this.hasCountTarget) this.countTarget.textContent = this.selectedIds.size
  }

  // Public API for sibling controllers (e.g. book-drag-drop)
  isActive() {
    return this.active
  }

  isCardSelected(bookId) {
    return this.selectedIds.has(String(bookId))
  }

  getSelectedIds() {
    return Array.from(this.selectedIds)
  }
}
